import React from "react";
import styled from "styled-components/macro";
import { PickerCard } from "./Picker";
import SCardForm from "../../root/library/sourceEdit/sourceCards/SCardForm";
import { useViewerDecks } from "../../queries/viewerQuery";
import DialogFullWindow from "../other/DialogFullWindow";

const Wrap = styled.div`
  padding: 10px 20px 25px 20px;
`;

type Props = {
  card?: PickerCard;
  source?: { id: string; name: string; lang: string; mine: boolean };
  onClose: VoidFunction;
};

const SCardFormWrapper: React.FC<Props> = ({ card, onClose, source }) => {
  const { deck } = useViewerDecks();
  const toLang = deck?.back || undefined;

  const handleSubmit = () => {
    onClose();
  };

  // Security check
  if (card && source && !source.mine) {
    throw Error("cannot edit others cards");
  }

  return (
    <DialogFullWindow open={!!card && !!source?.mine} onClose={onClose} background>
      <Wrap>
        <SCardForm sCard={card} source={source} backLang={toLang} onSubmit={handleSubmit} />
      </Wrap>
    </DialogFullWindow>
  );
};

export default SCardFormWrapper;
